import React , {useEffect, useState,useContext,useRef } from 'react';
import checkmark from '../images/checkmark.svg';
import square from '../images/square.svg'
import small_square from '../images/small_square.svg'
import small_checkmark from '../images/small_checkmark.svg'
import edit from '../images/edit.png'
import iconScrub from '../images/icon_scrubb.png'
import downArrow from "../images/arrow-down.svg";

import EditModal from './Modals/EditModal'
import alertIcon from '../images/Icon-Altert_Small.png';
import { keyContext } from '../components/KeyContext';

import moment from 'moment';
import { useFocusContext } from 'react-day-picker';
import InternetModal     from './Modals/InternetModal';
import InternetShowModal from './Modals/InternetShowModal';
import InternetSellModal from './Modals/InternetSellModal';
import NoteModal from './Modals/NoteModal';

import { useNavigate } from "react-router-dom";
import ErrorModal from './Modals/ErrorModal';


function FilmWidget({index, film, extendedBackColor,timelineBackColor,   priceDivBackColor,     start_Time,showTime,      end_Time,  salNr,
  internetOrderAll, internetSellAll, internetShowAll, ticketSellAll, ticketOrderAll, saveEditBtn, theWidth, arrtypename,price,webresinfo, webbuyinfo,webshowinfo,buyenabled,resenabled, movieLength, adTrailer, eventEdited,event_no,ref_no, theEvent, editedevent,movieNameColor,activeColor,  popupbg2, popupbg3, all_events, eventsEdit,numbered,daysEvent, theDraggedElm, dragging,onToggle,showPrice,filmDivHeight,showForstype,showPrimaryTkt,showStartEndtime,showInternetVis,showInternetOrder,showInternetSalg,chosenMovies,}) {

  const { selectAllFilmAtOnce, setSelectAllFilmAtOnce, selectedDate,calendarShow , setModalOpen, setMoviesSelected, moviesSelected , deletebtnclk,anyMovieSelected, setAnyMovieSelected,webEditing,editedEvId, setDivOpened,savebtnclk,alertEvents,setalertEvents,seteventEdit,eventsChanged,eventSaveObj, setEventSaveObj, setShowErrorModal,setErrorNo,setErrorText, setShowFilm, setShowDropdown, setClickedMovieDiv, setWaitingModal,setApiLoader,errorType, setErrorType,errorStatus, setErrorStatus,logOut,eventPushCheck,showErrorModal,errorNo,errorText,showTimePeriod,setCall_get_program,allTicketTypes} = useContext(keyContext)

  
  const navigate = useNavigate();
  const key = sessionStorage.getItem("key");
  const at = theEvent.eventObject.WebreserveInfo?.startTime
  const activeDate= moment('2000-01-01', 'YYYY-MM-DD').add(theEvent.eventObject.WebreserveInfo?.startDate - 146097, 'days').format('DD/MM/YY')

   const activeTime =  moment.utc(at*1000).format('HH:mm')
   const activeText =  `Aktiv fra ${activeDate} kl. ${activeTime}`
   const totalTimeInMin = movieLength+adTrailer
   const [adTime, setAdTime]= useState(theEvent.eventObject.AdvertisementTrailer);
  const [modalShown, toggleModal]             = useState(false);
  const [internetmodalShown, setInternetmodalShown]   = useState(false);
  const [intersellmodal, setIntersellmodal] = useState(false)
  const [intershowmodal,setIntershowmodal]  = useState(false)
  const [noteModalOpen, setnoteModalOpen] = useState();
  const [isShown, setIsShown]                 = useState(false);
  const [ openEventNo, setOpenEventNo ]       = useState()
  const [isActive, setIsActive]               = useState(false);
  const [movieSelected, setMovieSelected]     = useState(false);
  const [movieDivOpen, setMovieDivOpen]       = useState(false);

  const [internetOrder, setInternetOrder]     = useState()
  const [internetSell, setInternetSell]       = useState()
  const [internetShow, setInternetShow]       = useState(webshowinfo === 1 ? true :  false)
  const [ticketSellSell, setTicketSellSell]   = useState()
  const [ticketSellOrder, setTicketSellOrder] = useState()
  const [numberedSeat, setNumberedSeat]       = useState(theEvent.eventObject.hasNumberedSeats)
  const [staffInfoShown,setStaffInfoShown]    = useState(false)
  const [webInfoShown,setWebInfoShown]        = useState(false)
  const [staffText,setStaffText]              = useState('')
  const [webText, setWebText]                 = useState('');
  const [staffTextInput, setStaffTextInput ] = useState('')
  const [webTextInput, setWebTextInput]       = useState('');
  const [eventEdit, setEventEdit]             = useState(false);  // which is true/False in theEvent
  const [movieUnselect, setMovieUnselect]     = useState();
  const [trailerDivOpen, setTrailerDivOpen ]= useState();
  const [trailerChanged, setTrailerChanged] = useState(false);
 

 useEffect(() => {
  if(!chosenMovies.length) setMovieSelected(false)
 }, [chosenMovies]);

  useEffect(() => {
    eventsEdit.length && eventsEdit.map((ev) => { 
         all_events.map((oe) => {
            if(ev.No === oe.No) {
                if(ev.No === theEvent.event_No) {
                  setEventEdit(true)
                 }
          }
         })    
      })
     if(theEvent.eventObject.RefNo > 0) {
        setEventEdit(true)
      }
   
  }, [theEvent,eventsEdit,all_events]);




  const [showActiveText,setShowActiveText] = useState(false)

  useEffect(() => {
    if(theEvent.eventObject.WebreserveInfo?.startDate) { 
        if(theEvent.eventObject.WebreserveInfo?.startDate !== 0 && theEvent.eventObject.WebreserveInfo?.startTime !== 0) setShowActiveText(true)
        else setShowActiveText(false)
    }
  }, [theEvent]);

  useEffect(() => {
   setInternetOrder    (webresinfo  === 1 ? true :  false)
   setInternetSell     (webbuyinfo  === 1 ? true :  false)
   setInternetShow     (webshowinfo === 1 ? true :  false)
   setTicketSellSell   (buyenabled  === 1 ? true :  false)
   setTicketSellOrder  (resenabled  === 1 ? true :  false)
 
},[webresinfo,webbuyinfo,buyenabled,resenabled,theEvent,webshowinfo])

  const [aclicked,setAclicked] = useState(false) 
  const [bclicked,setBclicked] = useState(false)
  const [cclicked,setCclicked] = useState(false)
  const [dclicked,setDclicked] = useState(false)
  const [eclicked,setEclicked] = useState(false)
  const [numberedBtnClk,setNumberedBtnClk] = useState(false)
 
// useEffect(() => {
//    setAclicked(false)
// }, [selectedDate]);

  useEffect(() => {
     
     setStaffText(theEvent.eventObject.StaffInfo)
     setWebText(theEvent.eventObject.WebInfo)
    // setStaffText('just one hi')
  },[theEvent])
  
  function handleNumberedSeat () {
   
    setNumberedSeat((current) => !current)  // hasNumberedSeats
    setNumberedBtnClk((current) => !current)
  }



  const [reEdit, setReEdit] = useState(false);

  function handleStaffInfo (e) {   
    setStaffTextInput( e.target.innerHTML)
    if(webText) setReEdit(true)
    // setStaffText(e.target.value)
  }

  function handleWebInfo (e) { 
    setWebTextInput( e.target.innerHTML)
    if(staffText) setReEdit(true)
    // setStaffText(e.target.value)
  }

  const [clicked, setClicked] = useState();
  // const [open, setopen] = useState(false);
  let clicks = 0

  
  const handleClick = ( event_no) => {
   
 
    setClickedMovieDiv(event_no)
    setClicked(event_no)
   
   
     setMovieDivOpen((current) => !current)

    //  let isEven =clicked % 2 === 0
     setIsActive(current => !current); 

     // setOpenedDivsEvent(event_no)
       setOpenEventNo(event_no)  
       setStaffInfoShown(false)
       setWebInfoShown(false)
      

            var dropdowns = document.getElementsByClassName("dropdown2-content");
            var i;
            for (i = 0; i < dropdowns.length; i++) {
                    var openDropdown = dropdowns[i];
                
                    // or if divs display is not set to block
                     if(dropdowns[i].id == event_no && dropdowns[i].style.display == 'none' ) { 
                      dropdowns[i].style.display='block'
                 
                     }
                     else  { 
                       dropdowns[i].style.display='none'
                   
                     }
              
            }
  
  };
 
  useEffect(() => {
       let divs=  document.getElementsByClassName("dropdown2-content")
        var i;
            for (i = 0; i < divs.length; i++) {
              divs[i].style.display='none'
            }
  }, [selectedDate]);


  const staffInfoClick = () => {
    setStaffInfoShown((current) => !current)
    setReEdit(false)
    setStaffTextInput('')
  }

  const webInfoClick = () => {
    setWebInfoShown((current) => !current)
    setReEdit(false)
    setWebTextInput('')
  }

  useEffect(() => {
    modalShown === true ? setModalOpen(true) :  setModalOpen(false)
    modalShown === true && setShowFilm(false)
  },[modalShown,setModalOpen, setShowFilm])


 useEffect(() => {
   calendarShow === true && setIsShown(false)
 },[calendarShow])



const [the_result, setThe_result] = useState([])

let flag = false

  function fetchEventSave (event) {
    event.AllowOverlap = 1
     setWaitingModal(true)
  
      fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_save` ,{
        method: "POST",     
        headers: {
        'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        'Content-Type':  'application/x-www-form-urlencoded',    
       },     
       body:`Key=${key}&eventdata=${JSON.stringify(event)}`     
      })
      .then(res =>  { 
          
          
            flag =  true
         
        if(res.status === 200) {
          return   res.json() 

        }
        else {
          setShowErrorModal(true)
          setErrorStatus(res.status)
          setErrorType(res.type)       
        }
       
      })
      .then(result => { 

        setWaitingModal(false)
        setApiLoader(false)
           
            if(result.Result === 1) { 
            
                 theEvent.eventObject= result              
                 setEventSaveObj(result) 
                 setCall_get_program(result)
                 setAclicked(false)   
                 setBclicked(false)
                 setCclicked(false)
                 setDclicked(false)
                 setEclicked(false)
                 setNumberedBtnClk(false)
                 setnoteModalOpen(false)
                 setReEdit(false)
             }
          else if(result.Result === -1) {
            // console.log('call event push check')
            eventPushCheck()
          }
               else if (result.Result === 0) {
           // log out
           logOut()
           navigate('/')         
         }
             else {
                 setShowErrorModal(true)
                 setErrorNo(result.Result)
                 setErrorText(result.ErrorDescription)
              }
          
        }) 
       
        setTimeout(function () {
          if(flag === false) {
          
            setApiLoader(true)
         
            
          } 
         }, 2000)
  }



   // useEffect(() => {
  // if(aclicked === true ){
  //  theEvent.eventObject.WebreserveInfo  ?  
  //           (theEvent.eventObject.WebreserveInfo.enabled = internetOrder     === false ? 0 : 1) 
  //          :(theEvent.eventObject.WebreserveInfo = {enabled:internetOrder    === false ? 0 : 1})
  //        fetchEventSave(theEvent.eventObject)
  //           setWaitingModal(true)
  //         }
  // if(bclicked === true ){
  //    theEvent.eventObject.WebbuyInfo ? 
  //           (theEvent.eventObject.WebbuyInfo.enabled     = internetSell     === false ? 0 : 1) 
  //          :(theEvent.eventObject.WebbuyInfo = {enabled: internetSell       === false ? 0 : 1})
  //    fetchEventSave(theEvent.eventObject)
  //           setWaitingModal(true)
  //         }
  // if(cclicked === true){
  //      theEvent.eventObject.WebshowInfo? 
  //           (  theEvent.eventObject.WebshowInfo.enabled    = internetShow  === false ? 0 : 1) 
  //          :( theEvent.eventObject.WebshowInfo = {enabled:internetShow     === false ? 0 : 1})
  //  fetchEventSave(theEvent.eventObject)
  //           setWaitingModal(true)
  //         }
  // if(dclicked === true){
  //      theEvent.eventObject.BuyEnabled             = ticketSellSell  === false ? 0 : 1
  //   fetchEventSave(theEvent.eventObject)
  //           setWaitingModal(true)
  //     }
  // if(eclicked === true ){
  //       theEvent.eventObject.ReserveEnabled         = ticketSellOrder  === false ? 0 : 1
  //  fetchEventSave(theEvent.eventObject)
  //           setWaitingModal(true)
  //     }
  // if(numberedBtnClk === true){
  //     theEvent.eventObject.hasNumberedSeats = numberedSeat
       
  //           fetchEventSave(theEvent.eventObject)
  //           setWaitingModal(true)
  // }

  //    if(aclicked === true || bclicked === true || cclicked === true || dclicked === true || eclicked === true || numberedBtnClk === true ) {
  //            theEvent.eventObject.WebreserveInfo  ?  
  //           (theEvent.eventObject.WebreserveInfo.enabled = internetOrder     === false ? 0 : 1) 
  //          :(theEvent.eventObject.WebreserveInfo = {enabled:internetOrder    === false ? 0 : 1})

  //            theEvent.eventObject.WebbuyInfo ? 
  //           (theEvent.eventObject.WebbuyInfo.enabled     = internetSell     === false ? 0 : 1) 
  //          :(theEvent.eventObject.WebbuyInfo = {enabled: internetSell       === false ? 0 : 1})

  //            theEvent.eventObject.WebshowInfo? 
  //           (  theEvent.eventObject.WebshowInfo.enabled    = internetShow  === false ? 0 : 1) 
  //          :( theEvent.eventObject.WebshowInfo = {enabled:internetShow     === false ? 0 : 1})

  //            theEvent.eventObject.BuyEnabled             = ticketSellSell  === false ? 0 : 1

  //           theEvent.eventObject.ReserveEnabled         = ticketSellOrder  === false ? 0 : 1
  //           theEvent.eventObject.hasNumberedSeats = numberedSeat
       
  //           fetchEventSave(theEvent.eventObject)
  //           setWaitingModal(true)

     
  
  //  }
 //  }, )


  //---deleteing exixting staff info -------
  function deleteStaffInfo () {
    setStaffText('')
    theEvent.eventObject.StaffInfo = ''
    fetchEventSave(theEvent.eventObject)
    setStaffInfoShown(false)

  }
//-----adding staff info ----------
const [staffInfoSaved, setStaffInfoSaved] = useState(false);
const [webInfoSaved, setWebInfoSaved] = useState(false);


function saveStaffInfo () {

 theEvent.eventObject.StaffInfo = staffTextInput
 fetchEventSave(theEvent.eventObject)
 setStaffInfoShown(false)
 setStaffInfoSaved(true)
}
// deleting existing web info---
function deleteWebInfo() {
  setWebText('')
  theEvent.eventObject.WebInfo=''
  fetchEventSave(theEvent.eventObject)
  setWebInfoShown(false)
}
// -------ADDING WEB INFO-------
function saveWebInfo () {
theEvent.eventObject.WebInfo = webTextInput
fetchEventSave(theEvent.eventObject)
setWebInfoShown(false)
setWebInfoSaved(true)
}

useEffect(() => {
  setIsShown(false)
  setMovieSelected(false)
  setMovieDivOpen(false)
},[selectedDate,deletebtnclk,savebtnclk])

   useEffect(() => {
    //  if(saveEditBtn === false) {
            setMovieSelected(selectAllFilmAtOnce === true && selectAllFilmAtOnce) 
    //   }  
 },[selectAllFilmAtOnce,saveEditBtn])



const handleMovieSelect = () => { 

  setMovieSelected((current) => !current);
  // setMoviesSelected((current) => !current);

  setAnyMovieSelected(anyMovieSelected === true ? true : (current) => !current)
  movieSelected === true ? setMovieUnselect(true) : setMovieUnselect()
 
}



useEffect(() => {
  theEvent.movieSelected = movieSelected
 
  //  theEvent.movieSelected === true && setSelectedMovieEvent(theEvent)
 
}, [movieSelected, theEvent]);


useEffect(() => {
  selectAllFilmAtOnce === false ? setMovieUnselect(false) :  setMovieUnselect()
}, [selectAllFilmAtOnce]);

useEffect(() => {
  daysEvent.map((ev) => {
    if(ev.event_No === theEvent.event_No) {
      theEvent.isOpen = movieDivOpen
    }
    else theEvent.isOpen = false
  })
  
}, [theEvent,movieDivOpen,daysEvent]);


 function handleInternetSell ()  {

   setBclicked((current) => !current)
   setInternetSell((current) => !current) // internet salg
 
   const newValue = theEvent.eventObject.WebbuyInfo.enabled === 1 ? 0 : 1 
   
    theEvent.eventObject.WebbuyInfo ?
    (theEvent.eventObject.WebbuyInfo.enabled = newValue) : (theEvent.eventObject.WebbuyInfo = {enabled : 1})

    fetchEventSave(theEvent.eventObject)
    setWaitingModal(true)
 }

 function handleInternetShow ()   {
 
   setCclicked((current) => !current)
   setInternetShow((current) => !current) // intervisning
  
   const newValue = theEvent.eventObject.WebshowInfo.enabled === 1 ? 0 : 1 
   
    theEvent.eventObject.WebshowInfo ?
    (theEvent.eventObject.WebshowInfo.enabled = newValue) : (theEvent.eventObject.WebshowInfo = {enabled : 1})
   
    fetchEventSave(theEvent.eventObject)
    setWaitingModal(true)

   
 }
 function handleTicketSellSell  ()  {
   setDclicked((current) => !current)
   setTicketSellSell((current) => !current) // salg i billetsalg
 
   theEvent.eventObject.BuyEnabled === 1 ? theEvent.eventObject.BuyEnabled = 0 : theEvent.eventObject.BuyEnabled = 1 
   fetchEventSave(theEvent.eventObject)
    setWaitingModal(true)
 }
 function handleTicketSellOrder  ()  {
   setEclicked((current) => !current)
   setTicketSellOrder((current) => !current) // bestilling i billetsalg

 theEvent.eventObject.ReserveEnabled === 1 ? theEvent.eventObject.ReserveEnabled = 0 : theEvent.eventObject.ReserveEnabled = 1 
   fetchEventSave(theEvent.eventObject)
    setWaitingModal(true)
 }
 
  function handleInternetOrder  (theEvent)  {
    setInternetOrder((current) => !current) // internetbestilling
    setAclicked((current) => !current)
 
   const newValue = theEvent.eventObject.WebreserveInfo.enabled === 1 ? 0 : 1 
    
    theEvent.eventObject.WebreserveInfo ?
    (theEvent.eventObject.WebreserveInfo.enabled = newValue) : (theEvent.eventObject.WebreserveInfo = {enabled : 1})
   
    fetchEventSave(theEvent.eventObject)
    setWaitingModal(true)
  }
  
 
  // function that checks if webreserveInfo is different in original and eventedit events
 function alertWebres (event) {

  let alert 
  all_events.map((ev) => {
       if(ev.No === event.event_No) {         
          if(event.eventObject.WebreserveInfo.enabled !== ev.WebreserveInfo.enabled) {
            alert = true
                     
          }
       }
    })
    return alert
 }
  // function that checks if webbuyInfo is different in original and eventedit events
  function alertWebbuy (event) {
    let alert
      all_events.map((ev) => {
         if(event.event_No === ev.No) {
            if(event.eventObject.WebbuyInfo.enabled !== ev.WebbuyInfo.enabled) {
              alert = true
              
            }
         }
      })
      return alert
   }
     // function that checks if webshowInfo is different in original and eventedit events
  function alertWebshow (event) {
    let alert
      all_events.map((ev) => {
         if(event.event_No === ev.No) {
            if(event.eventObject.WebshowInfo.enabled !== ev.WebshowInfo.enabled) {
              alert = true
             
            }
         }
      })
      return alert
   }
    // function that checks if buyEnabled is different in original and eventedit events
  function alertbuyEnabled (event) {
    let alert
      all_events.map((ev) => {
         if(event.event_No === ev.No) {
            if(event.eventObject.BuyEnabled !== ev.BuyEnabled) {
              alert = true
             
            }
         }
      })
      return alert
   }
// function that checks if buyEnabled is different in original and eventedit events
function alertresEnabled (event) {
  let alert
    all_events.map((ev) => {
       if(event.event_No === ev.No) {
       
          if(event.eventObject.ReserveEnabled !== ev.ReserveEnabled) {
            alert = true
            
          }
       }
    })
    return alert
 }

 function alertNumbered (event) {
    let alert   
    all_events.map((ev) => {
      if(event.event_No === ev.No) {
       
        if(event.eventObject.hasNumberedSeats !== ev.hasNumberedSeats) {
          alert = true
        
        }
  }
    })
  
    return alert
 }

 function alertWebinfo (event) {
   let alert
   all_events.map((ev) => {
      if(event.event_No === ev.No) {
          if(event.eventObject.WebInfo !== ev.WebInfo) {
            alert= true
          }
      }
   })
   return alert
 }
 
 function alertStaffinfo (event) {
  let alert
  all_events.map((ev) => {
     if(event.event_No === ev.No) {
         if(event.eventObject.StaffInfo !== ev.StaffInfo) {
           alert= true
         }
     }
  })
  return alert
 }

  const trailerWidth = theWidth * (adTrailer/movieLength)   // film div width

  const [maxTickets, setmaxTickets] = useState(theEvent.eventObject.MaxTickets);
  const [minTickets, setminTickets] = useState(theEvent.eventObject.MinTickets);

  function maxTicketChange (e) {
    setmaxTickets(e.target.value)
    let newMax = Number(e.target.value)
    theEvent.eventObject.MaxTickets = e.target.value > 0 ?  newMax : 0   
    fetchEventSave(theEvent.eventObject)
  }


  function minTicketChange (e) {  
    setminTickets(e.target.value)
    let newMin = Number(e.target.value)
    theEvent.eventObject.MinTickets = e.target.value > 0 ?  newMin : 0
   fetchEventSave(theEvent.eventObject)

  }


      function PrimaryTicket () {
        let ticket_name 
        allTicketTypes.filter((tkt) => {
         theEvent?.eventObject?.TicketTypes?.filter((ticket) => {
          if(tkt.No === ticket.No && tkt.Default === 1 ) {
          
            ticket_name = tkt.Name
          }
          return ticket_name
         })
          return ticket_name

      })
          return ticket_name

   }

   function handleTrailerTime () {
       setTrailerDivOpen((current => !current))
   }

   function saveTrailerTime () {
     
      theEvent.eventObject.AdvertisementTrailer = Number(adTime)
    
       fetchEventSave(theEvent.eventObject)
      setTrailerChanged(false)
      setTrailerDivOpen(false)
   }

   function deleteTrailerTime () {
    setAdTime(0)
    theEvent.eventObject.AdvertisementTrailer = 0
    fetchEventSave(theEvent.eventObject)
    setTrailerChanged(false)
    setTrailerDivOpen(false)
    }

   function handleTimeChange (e) {
     setTrailerChanged(true)
     setAdTime(e.target.value)
   }

  return (
        
  <div style={{height:filmDivHeight+'px',}}> 
     <div  style={{position:'relative',display:'flex',padding:'0',justifyContent:'space-between',border:  theEvent.eventObject.RefNo > 0 &&  eventEdit === true && theEvent.eventObject.DeleteEvent !== 1 ? '1px solid #982F2F' : '',borderRadius:'4px',height:'100%'}}>
          {/* <span style={{position:'absolute',top:'-20px',fontSize:'12px'}}>
            {showTime && start_Time}</span>        */}
      <div className="shown_menu" style={{flex:1,minWidth:0,height:filmDivHeight+'px',display:'flex', justifyContent:'space-between'}}>
         <section style={{width:'100%',display:'flex',flexDirection:'column',border:'1px '}}>
            <div className="" style={{display:'flex',width:'100%',paddingRight:'10px',alignItems:'center',height:'24px'}}>

            {theDraggedElm.event_No === theEvent.event_No && dragging === true && theDraggedElm.event_No > 0 ?
             <span style={{position:'absolute',top:'0px',fontSize:'12px',left:'-32px',zIndex:100,}}>{start_Time}</span>
               : null }
 
            { theDraggedElm.eventObject?.RefNo === theEvent.eventObject.RefNo && dragging === true && theDraggedElm.event_No === theEvent.event_No?
             <span style={{position:'absolute',top:'0px',fontSize:'12px',left:'-32px',zIndex:100,}}>{start_Time}</span> : null }

              <span ><img className='doubleLine' style={{background:'transparent' , }}  src={iconScrub} alt='icon-scrub'/></span> 
              <div  className='film_check' 
                onClick={ () => { onToggle(theEvent); handleMovieSelect()}}
              
               style={{background:'none'}}>
                <span>
                  {(movieSelected === true ||  selectAllFilmAtOnce === true) && movieUnselect !== true ?
                  <svg id={event_no > 0 ? event_no : ref_no} width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.75" y="1.25" width="14.5" height="14.5" rx="1.91667" stroke={movieNameColor}  stroke-width="1.5"/>
                  <path d="M5 7.44495L7.30044 10.6429L11 5.5" stroke={movieNameColor} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  :
                  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <rect x="0.75" y="1.25" width="14.5" height="14.5" rx="1.91667" stroke={movieNameColor} stroke-width="1.5"/>
                  </svg>
                  }
                </span>
                 
              </div>
              {theEvent.eventObject.DeleteEvent === 1 ? <span style={{color:'#982F2F',marginRight:'9px',marginBottom:'2px'}}>Slettet</span> : ''}
              { localStorage.getItem('showTimePeriod') === 'true'? <div style={{position:'relative',width:'100%'}}> 
                         {/* <p className='film_name' style={{color:movieNameColor,textDecoration:'underline',background:'none',position:'absolute',top:'-10px',fontSize:'14px'}}>{start_Time +'-'+ end_Time}</p>
                         <p className='film_name' style={{color:movieNameColor,textDecoration:'underline',background:'none',position:'absolute',top:'6px',width:'100%'}}>{film}</p> */}
              </div> 
              : 
              <>
              {showInternetOrder === true && theEvent.eventObject.WebreserveInfo.enabled === 1 ?
              <span style={{position:'relative',top:'-2px',left:'-5px',marginRight:'5px'}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
<path d="M15.6667 12H14.6667V2.33329C14.6667 1.9651 14.3682 1.66663 14 1.66663H2C1.63181 1.66663 1.33333 1.9651 1.33333 2.33329V12H0.333333C0.149238 12 0 12.1492 0 12.3333V12.6666C0 13.0348 0.298477 13.3333 0.666667 13.3333H15.3333C15.7015 13.3333 16 13.0348 16 12.6666V12.3333C16 12.1492 15.8508 12 15.6667 12ZM2.66667 2.99996H13.3333V11.3333H2.66667V2.99996Z" fill={theEvent.index === 0 || theEvent.index === 3 ||  theEvent.index === 4 ? '#46484C' :  "white" }/>
</svg>
<span style={{position:'absolute',left:'4px'}}>
 <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
<g clip-path="url(#clip0_3249_26313)">
<path d="M7.00007 3.67859V4.32145C7.00007 4.49897 6.85616 4.64288 6.67864 4.64288H4.64291V6.67861C4.64291 6.85613 4.499 7.00004 4.32148 7.00004H3.67862C3.5011 7.00004 3.35719 6.85613 3.35719 6.67861V4.64288H1.32146C1.14394 4.64288 1.00003 4.49897 1.00003 4.32145V3.67859C1.00003 3.50107 1.14394 3.35716 1.32146 3.35716H3.35719V1.32143C3.35719 1.14391 3.5011 1 3.67862 1H4.32148C4.499 1 4.64291 1.14391 4.64291 1.32143V3.35716H6.67864C6.85616 3.35716 7.00007 3.50107 7.00007 3.67859Z" fill={theEvent.index === 0 || theEvent.index === 3 ||  theEvent.index === 4 ? '#46484C' :  "white" }/>
</g>
<defs>
<clipPath id="clip0_3249_26313">
<rect width="8" height="8" fill="white"/>
</clipPath>
</defs>
</svg> 
</span>
              </span>
              : ''}
              { showInternetSalg === true && theEvent.eventObject.WebbuyInfo.enabled === 1 ? 
              <span style={{position:'relative',top:'-2px',left:'-5px',marginRight:'5px'}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<g clip-path="url(#clip0_3356_26078)">
<path d="M15 6.66671H12.3334L8.48669 1.53337C8.39093 1.40908 8.24358 1.33541 8.08669 1.33337H7.91335C7.75646 1.33541 7.60911 1.40908 7.51335 1.53337L3.66669 6.66671H1.00002C0.815925 6.66671 0.666687 6.81595 0.666687 7.00004V7.66671C0.666687 7.8508 0.815925 8.00004 1.00002 8.00004H1.33335L2.47335 13.1C2.67434 14.006 3.47211 14.6547 4.40002 14.6667H11.6C12.5354 14.664 13.344 14.0132 13.5467 13.1L14.6667 8.00004H14.98C15.1641 8.00004 15.3134 7.8508 15.3134 7.66671V7.00004C15.3137 6.82348 15.1763 6.6773 15 6.66671ZM5.33335 6.66671L8.00002 3.11337L10.6667 6.66671H5.33335Z" fill= {theEvent.index === 0 || theEvent.index === 3 ||  theEvent.index === 4 ? '#46484C' :  "white" }/>
</g>
<defs>
<clipPath id="clip0_3356_26078">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
              </span> : ''}

              {showInternetVis === true && theEvent.eventObject.WebshowInfo.enabled === 1?   <span style={{position:'relative',top:'-2px',left:'-5px',marginRight:'5px'}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<g clip-path="url(#clip0_3356_26087)">
<path d="M14.6585 7.79993C13.5721 5.07757 10.9254 3.30316 7.99593 3.33326C5.08598 3.31643 2.46074 5.07911 1.3733 7.77993C1.34769 7.85049 1.33417 7.92487 1.33332 7.99993C1.33297 8.07078 1.34655 8.141 1.3733 8.2066C2.45651 10.9127 5.08269 12.6813 7.99593 12.6666C10.9059 12.6834 13.5311 10.9208 14.6186 8.21993C14.6471 8.15019 14.6607 8.07525 14.6585 7.99993C14.6693 7.9337 14.6693 7.86616 14.6585 7.79993ZM7.99593 9.99993C6.89203 9.99993 5.99714 9.1045 5.99714 7.99993C5.99714 6.89536 6.89203 5.99993 7.99593 5.99993C9.09982 5.99993 9.99471 6.89536 9.99471 7.99993C9.99471 8.53036 9.78412 9.03907 9.40928 9.41414C9.03443 9.78922 8.52604 9.99993 7.99593 9.99993Z" fill={theEvent.index === 0 || theEvent.index === 3 ||  theEvent.index === 4 ? '#46484C' :  "white" }/>
</g>
<defs>
<clipPath id="clip0_3356_26087">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
              </span> : '' }

      <p className='film_name' style={{color:movieNameColor,textDecoration:'underline',background:'none',width:'100%'}}>
              {localStorage.getItem('showTimePeriod') === 'true'?  start_Time +'-'+ end_Time+' : ' + film : film }
      </p>
    
        </>
              }
             
              

            </div>
      {showPrice === true ? <p style={{fontSize:'12px',margin:0,fontWeight:'bold',border:'1px solid rgba(255, 255, 255, 0.40)',marginLeft:'20px',borderRadius:'3px',background:'rgba(255, 255, 255, 0.40)',height:'16px',width:'fit-content',padding:'0px 5px',lineHeight:'14px',marginBottom:'4px'}}> {price} dkk</p> : ''}

      <div style={{display:'flex'}}>
        {showPrimaryTkt === true ? <p style={{fontSize:'12px',margin:0,fontWeight:'bold',border:PrimaryTicket()?'1px solid rgba(255, 255, 255, 0.40)':'',marginLeft:'20px',borderRadius:'3px',background:'rgba(255, 255, 255, 0.40)',height:'16px',width:'fit-content',lineHeight:'14px',marginBottom:'4px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',padding:PrimaryTicket()?'0px 5px':'0px'}}> {PrimaryTicket()}</p> : ''}
         {showForstype === true  ? <p style=
         {{fontSize:'12px',margin:0,fontWeight:'bold',border:theEvent.eventObject.ArrTypeName ? '1px solid rgba(255, 255, 255, 0.40)' : '',marginLeft:'20px',borderRadius:'3px',background:'rgba(255, 255, 255, 0.40)',height:'16px',width:'fit-content',lineHeight:'14px',marginBottom:'4px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',padding:theEvent.eventObject.ArrTypeName ? '0px 5px': ''}}> {theEvent.eventObject.ArrTypeName} </p> : '' }
             
           </div>  
      {showStartEndtime === true ? <p style={{fontSize:'12px',margin:0,fontWeight:'bold',border:'1px solid rgba(255, 255, 255, 0.40)',marginLeft:'20px',borderRadius:'3px',background:'rgba(255, 255, 255, 0.40)',height:'16px',width:'fit-content',padding:'0px 5px',lineHeight:'14px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}> {start_Time} - {end_Time}</p> : '' }
   </section>
   
          </div>
 {/* <div style={{width:'47px'}}> */}
      {/* alert icon */}
       {
      theEvent.eventObject.RefNo > 0 &&  eventEdit === true && theEvent.eventObject.DeleteEvent !== 1 ? 
      <span style={{position:'absolute',right:theEvent.movieLength === false ? '44px':'24px',background:' linear-gradient(0deg, #ececec 25%, hsla(0, 0%, 100%, 0));'}}>
              
   <svg style={{marginBottom:'5px'}} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
<circle cx="10" cy="10" r="8" fill="#982F2F"/>
<path d="M10.65 15C10.8667 15 11 14.8634 11 14.6245V13.3442C11 13.1223 10.8667 13 10.65 13H9.35C9.13333 13 9 13.1223 9 13.3442V14.6245C9 14.8634 9.13333 15 9.35 15H10.65ZM10.65 11.3585C10.8667 11.3585 11 11.2219 11 11V5.35846C11 5.13656 10.8667 5 10.65 5H9.35C9.13333 5 9 5.13656 9 5.35846V11C9 11.2219 9.13333 11.3585 9.35 11.3585H10.65Z" fill="white"/>
</svg>

     
       </span>   : ''
       } 
       {/* no movie length icon */}
 {theEvent.movieLength === false ? 
       <span style={{position:'absolute',right:'24px',}}>
       <svg style={{marginBottom:'5px',}} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="8" fill="#982F2F"/>
<path d="M10.5389 4.0004C10.4022 3.99494 10.2692 4.04532 10.1706 4.13989C10.0721 4.23446 10.0164 4.36505 10.0165 4.50149V10.0436L6.159 13.912C6.05756 14.0067 6 14.1392 6 14.2778C6 14.4164 6.05756 14.5488 6.159 14.6436C8.15972 16.2742 10.9796 16.4514 13.1696 15.0842C15.3596 13.717 16.4327 11.1094 15.8374 8.60134C15.2421 6.09332 13.1109 4.24269 10.5389 4.0004Z" fill="white"/>
</svg> 

        </span> : ''}
     {/* </div> */}
          <button className="arrow_btn" style={{marginLeft:'0px', flex:'0 0 24px',marginTop:'0px',background:'rgba(255, 255, 255, 0.40)',borderTopRightRadius:'4px',borderBottomRightRadius:'4px'}} id={event_no > 0 ? event_no : ref_no} 
          onClick= { () =>  handleClick(event_no) }
          // onClick={toggleOpen}
          >
                <span  id={event_no}> 
                  <svg  id={event_no} style={{marginBottom:'4px'}}  xmlns="http://www.w3.org/2000/svg" width="8" height="10" viewBox="0 0 15 9" >
                  <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                  <g stroke={theEvent.movieLength === false ? 'black' :movieNameColor } strokeWidth="2.5">
                  <g>
                  <path d="M934 19.25L940.5 26.25 947 19.25" transform="translate(-1053 -509) translate(120 491)"/>
                   </g>
                   </g>
                   </g>
                   </svg> 
                </span>
        </button>
     

      {/* ALERT ICON when show edit begins  */}
    {/* {
      theEvent.eventObject.RefNo > 0 &&  eventEdit === true  ? 
     <img style={{position:'absolute',right:'-5px',top:'17px',zIndex:1}} src={alertIcon} alt='alert-icon' /> : ''
       }  */}
        
       
    </div>  
  
    <div id={event_no} className="dropdown2-content" style={{display:'none',width:'100%',position:'absolute',zIndex:10,}}>
    <div id='filmInfoDiv' className='div' style={{position:'relative', 
      zIndex: modalShown === true || internetmodalShown === true || intersellmodal === true || intershowmodal === true ? '' : staffInfoShown ? 1: 4, backgroundColor:  extendedBackColor ,marginTop: '-2px' , borderBottomLeftRadius:'4px', borderBottomRightRadius:'4px',}}>
   
    <>
          <main style={{padding: theWidth > 160 ? '5px' :'0px'}}>
           <div style={{paddingLeft: theWidth > 210 ? '8px' :'0px'}}>
            <p  style={{margin:0,paddingTop:'0px',color:'#46484c',display: theWidth < 120 ? '' : 'flex',height:theWidth < 90 ? '50px':'25px',flexDirection: theWidth < 90 ? 'column' : '',paddingLeft:theWidth<160?'5px':'',}}> 
              <p className='sal_name text_elip' style={{fontWeight:700,paddingRight:'10px',width:'auto',maxWidth: theWidth < 120 ? '100%' :'50%',letterSpacing:'0.24px'}}>{salNr}</p> 
              <p className='text_elip' style={{fontSize: theWidth < 185 ? '12px': '15px', lineHeight:theWidth < 120 ? '10px' : '23px',margin:0}}>{start_Time} - {end_Time} </p>
              </p>
            
            <div style={{paddingTop: theWidth < 120 ? ' 15px' : '10px',paddingLeft:theWidth<160?'5px':''}}>
         
               <div style={{display:'flex',marginTop:'0px',border:'1px ',height:'13px',marginBottom:showActiveText?'':'3px',position:'relative'}}>
               <img  onClick={() => handleInternetOrder(theEvent)} src= {
                selectAllFilmAtOnce === true ?
               ( (movieSelected === true && internetOrderAll === 1)  ?  small_checkmark   :    (movieSelected === true && internetOrderAll === 0) ? small_square 
                : theEvent.eventObject.WebreserveInfo?.enabled === 1 ? small_checkmark : small_square 
              ) 
                : (
                  internetOrder === true  ?  small_checkmark : small_square
                )
                 }  alt="checkmark"  />
                 <p onClick={(e) => {
                          setInternetmodalShown(!internetmodalShown);
                          
                      }} style={{fontSize:'12px',color:'#46484c',margin:'-4px 8px',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',textDecoration:'underline',cursor:'pointer'}}>Internetbestilling  </p>
               
                {  alertWebres(theEvent) === true  ? <img src={ alertIcon} alt='alert-icon' style={{position:'absolute',right:'0px'}} /> : '' }

               </div>
               {showActiveText === true ? 
               <p className='text_elip' style={{marginLeft:'20px',marginBottom:'2px',marginTop:'-2px',fontSize:'10px',fontWeight:700,letterSpacing:'0.2px',color:activeColor}}>{activeText}
               </p>
               : ''}
               <InternetModal
        shown={internetmodalShown}
        close={() => {
          setInternetmodalShown(false);
        }} activeColor={activeColor}  popupbg2={popupbg2} sec1color = {extendedBackColor} sec2color={popupbg2} sec3color={popupbg3} data={theEvent.eventObject} setShowActiveText={setShowActiveText}></InternetModal>
              

               <div  style={{display:'flex',margin:0,padding:0,height:'13px',marginBottom:'3px',border:'1px ',position:'relative'}} >
               <img onClick={() => handleInternetSell()}  src= {
                 selectAllFilmAtOnce === true ?
                 ((movieSelected === true &&  internetSellAll === 1)  ?  small_checkmark   : (movieSelected === true &&  internetSellAll === 0) ? small_square 
                 : internetSell === true ? small_checkmark : small_square

                 )
               : (  theEvent.eventObject?.WebbuyInfo?.enabled === 1   ?  small_checkmark : small_square )
               }  alt=""  />
                 <p onClick={(e) => { setIntersellmodal(!intersellmodal);
   }} style={{fontSize:'12px',padding:'0px',margin:'-4px 8px',color:'#46484c',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',textDecoration:'underline',cursor:'pointer'}}>Internet salg</p>
                      
                 { alertWebbuy(theEvent) === true ? <img src={ alertIcon} alt='alert-icon' style={{position:'absolute', right:'0px'}} /> :''}
               </div>
               <InternetSellModal
        shown={intersellmodal}
        close={() => {
          setIntersellmodal(false);
        }} activeColor={activeColor} popupbg2={popupbg2} sec1color = {extendedBackColor} sec2color={popupbg2}   data={theEvent.eventObject} />
               <div  style={{display:'flex',margin:0,padding:0,height:'13px',marginBottom:'3px',border:'1px ',position:'relative'}} >
               <img onClick={() => handleInternetShow()} src= {
                selectAllFilmAtOnce === true ?
                ((movieSelected === true &&  internetShowAll === 1)  ?  small_checkmark   : (movieSelected === true &&  internetShowAll === 0) ? small_square 
                : 
                theEvent.eventObject.WebshowInfo?.enabled === 1 ? small_checkmark : small_square)
              :  (internetShow === true   ?  small_checkmark : small_square )}  alt=""  />
                 <p onClick={(e) => {
                          setIntershowmodal(!intershowmodal);
                          
                      }} style={{fontSize:'12px',padding:'0px',margin:'-4px 8px',color:'#46484c',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',textDecoration:'underline',cursor:'pointer'}}>Internetvisning</p>
                 {  alertWebshow(theEvent) === true ? <img src={ alertIcon} alt='alert-icon' style={{position:'absolute', right:'0px'}} /> :'' }
               </div>
      <InternetShowModal
        shown={intershowmodal}
        close={() => {
          setIntershowmodal(false);
        }} activeColor={activeColor} popupbg2={popupbg2} sec1color = {extendedBackColor} sec2color={popupbg2}  data={theEvent.eventObject}/>
               <div  style={{display:'flex',margin:0,padding:0,height:'13px',marginBottom:'3px',border:'1px',position:'relative'}} >
               <img onClick={() => handleTicketSellSell()} src= {
                selectAllFilmAtOnce === true ?
                ((movieSelected === true &&  ticketSellAll === 1)  ?  small_checkmark   : (movieSelected === true &&  ticketSellAll === 0) ? small_square 
                : theEvent.eventObject.BuyEnabled === 1 ? small_checkmark : small_square)            
               : ( ticketSellSell === true  ?  small_checkmark : small_square) }  alt=""  />
                 <p onClick={(e) => {
                          
                      }} style={{fontSize:'12px',padding:'0px',margin:'-4px 8px',color:'#46484c',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',}}>Salg i billetsalg</p>
                 {  alertbuyEnabled(theEvent) === true ? <img src={ alertIcon} alt='alert-icon'  style={{position:'absolute',right:'0px'}}/> :'' }
               </div>

               <div  style={{display:'flex',margin:0,padding:0,height:'13px',marginBottom:'3px',border:'1px ',position:'relative'}} >
               <img onClick={() => handleTicketSellOrder()} src= {
                selectAllFilmAtOnce === true ?
                (
                  (movieSelected === true &&  ticketOrderAll === 1)  ?  small_checkmark   : (movieSelected === true &&  ticketOrderAll === 0) ? small_square 
                : theEvent.eventObject.ReserveEnabled === 1 ? small_checkmark : small_square
                )
                : (ticketSellOrder === true   ?  small_checkmark : small_square) }  alt=""  />
                 <p onClick={(e) => {                        
                      }} style={{fontSize:'12px',padding:'0px',margin:'-4px 8px',color:'#46484c',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',}}>Bestilling i billetsalg</p>
                  {  alertresEnabled(theEvent) === true ? <img src={ alertIcon} alt='alert-icon' style={{position:'absolute',right:'0px'}} /> : '' } 
               </div>
             

            </div>
         
         </div>
         <div style={{display:'flex',fontSize:'12px',marginTop:'20px',marginLeft:'5px',marginRight:'5px'}}>
          <label htmlFor="" style={{width:'90%',backgroundColor:'transparent',lineHeight:'12px'}}> Internet restriktion for maximum billetter :</label>
          <select name="" value={maxTickets} onChange={maxTicketChange} id="" style={{width:'61px',height:'22px',marginTop:'-5px'}}>
            <option value="ingen">Ingen</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>

          </select>
       
         </div>
         <div style={{display:'flex',fontSize:'12px',marginTop:'10px',marginLeft:'5px',marginRight:'5px'}}>
          <label htmlFor="" style={{width:'90%',backgroundColor:'transparent',lineHeight:'12px'}}> Internet restriktion for minimum billetter :</label>
          <select name="" id="" value={minTickets} onChange={minTicketChange} style={{width:'61px',height:'22px',marginTop:'-5px'}}>
            <option value="ingen">Ingen</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
          </select>
       
         </div>
       
         <div style={{marginTop:'10px',color:'#46484c',backgroundColor:priceDivBackColor,position:'relative',padding:'5px',borderRadius:'4px'}}>
           <div id='priceDiv1' style={{display:'flex',flexDirection:'column',justifyContent:'center'}}>
            <p  style={{fontSize:'12px',margin:0, paddingTop:'4px',fontWeight:'bold'}}>{price} dkk</p>
            <p className='text_elip' style={{fontSize:'12px',margin:0 }}>{arrtypename}</p>
            <p className='text_elip'  style={{fontSize:'12px',margin:0 }}>
            Billettype: {theEvent.eventObject.TicketTypes?.length ?  theEvent.eventObject.TicketTypes.length : 0} valgte</p>
           </div>
           
           {/* <div  id='priceDiv2' style={{backgroundColor:priceDivBackColor,textAlign:'center',borderTopRightRadius:'5px',borderBottomRightRadius:'5px',width:'37%',alignContent:'center'}}> */}
            <button style={{border:'none',background:'transparent',textDecoration:'underline', fontFamily:'lato',color:'#46484c',fontSize:'12px',
            //  lineHeight:theWidth > 170 ?'50px' : '',
            padding:0,position:'absolute',right:'6px', top:'4px'}} onClick={() => {
                          toggleModal(!modalShown);
                      }}><img src={edit} alt ='edit'/>
            </button>

           {/* </div> */}
           
           <EditModal
        shown={modalShown}
        close={() => {
          toggleModal(false);
        }}
       movie_name={film} sal_nr={salNr} start_time={start_Time} end_time={end_Time} the_Event={theEvent.eventObject} priceGroups={ theEvent.PriceGroups} color1={extendedBackColor} color2={activeColor}  all_events={all_events}
      >   
        </EditModal>
         </div>

         <div style={{padding:'5px',display:'flex',marginLeft:theWidth>160?'5px':'0px',position:'relative',cursor:'pointer'}} onClick={() => handleNumberedSeat(theEvent)}>
              <span> 
                <img style={{height:'13px'}} 
                src={numberedSeat === true ? small_square : small_checkmark} 
                alt="checkmark/square" />
              </span> 
              <span style={{fontSize:'12px',marginLeft:'5px',marginTop:'4px'}} className='text_elip'>Unummererede billetter</span>
           { alertNumbered(theEvent) === true ?  
           <img src={ alertIcon} alt='alert-icon' style={{position:'absolute', right:'0px',top:'10px'}} />
            : ''}
          </div>


      
          </main>
         
         
          </>
       
          
    </div>
    <section style={{zIndex:trailerDivOpen?15:3,position:'relative',backgroundColor: extendedBackColor,marginTop:'-2px',paddingTop:trailerDivOpen? '':'2px',paddingBottom:'10px'}}> 
         <div onClick={handleTrailerTime} style={{height:'20px',borderRadius:trailerDivOpen ? '' :'4px',display:'flex', justifyContent:'space-between',backgroundColor:timelineBackColor,fontSize:'13px',color:movieNameColor,cursor:'pointer',margin:trailerDivOpen ? '' :'0px 10px'}}>
           <span style={{backgroundColor:adTrailer ? '#8d8e7e':'', width: adTrailer ? 
            `${Math.round(trailerWidth)}px` : '0px',borderTopLeftRadius:'2px',borderBottomLeftRadius:'2px',paddingLeft:'2px'}}>0:{adTrailer > 9 ? '':'0'}{adTrailer}</span> 
           <span style={{fontWeight:'bold', paddingRight:'2px'}}>0{Math.floor(totalTimeInMin / 60) + ':'}{(totalTimeInMin % 60) < 10 ? '0'+ totalTimeInMin % 60 :  totalTimeInMin % 60}</span>         
         </div>
      { trailerDivOpen ? 
        <div style={{padding:'0px 5px',backgroundColor: extendedBackColor,height:'55px'}}>  
          <div style={{display:'flex',justifyContent:'space-between',height:'20px'}}> 
             <p className='text-elip' style={{fontSize:'12px',lineHeight:'25px'}}>Trailer/Reklame tid</p>
             <div><button disabled = {trailerChanged ? false : true} onClick={saveTrailerTime} style={{fontSize:'12px'}}>Gem</button>
               <button disabled = {adTime > 0 ? false : true} onClick={deleteTrailerTime} style={{fontSize:'12px',}}>Slet</button>
               <button style={{marginRight:theWidth > 160?'-5px':''}} 
                onClick={() => setTrailerDivOpen(false)} 
               >
               <svg style={{ transform:'rotate(180deg)'}}  xmlns="http://www.w3.org/2000/svg" width="8" height="10" viewBox="0 0 15 9" >
                  <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                  <g stroke="#46484c" strokeWidth="2.5">
                  <g>
                  <path d="M934 19.25L940.5 26.25 947 19.25" transform="translate(-1053 -509) translate(120 491)"/>
                   </g>
                   </g>
                   </g>
                </svg>  
               </button>
             </div>
          </div> 
          <input type="number"  value={adTime} onChange={(e)=>handleTimeChange(e)} style={{height:'25px',width:'100%',marginTop:'5px'}}/>
        </div>
       :''}
  </section>
    <div style={{backgroundColor: extendedBackColor,borderTop:'2px solid  white',borderRadius:'4px',height:staffInfoShown?'auto':'29px',fontSize:'12px',zIndex:staffInfoShown ? 15 :3,position:'relative',paddingTop:'3px',minHeight:staffInfoShown?'70px':''}}>
    <div style={{display:'flex',justifyContent:'space-between',padding: theWidth > 190 ? '0px 10px' : theWidth > 140 ? '0px 5px':'',alignItems:'center'}}>
      <div style={{position:'relative'}}>
        <span className='text_elip' style={{marginTop:'2px', width: theWidth<140 ? '60px':''}}>Note i BilletPro</span> 
         { alertStaffinfo (theEvent) === true ? <img src={ alertIcon} alt='alert-icon' style={{position:'absolute', right:'-18px',top:'4px'}} /> : ''}
       </div>
       <div> 
           {staffInfoShown ? 
           <>
           {/* { staffText.length ?  */}
           <button  onClick={deleteStaffInfo}
            disabled={ staffText || staffTextInput
               // (staffText == null && staffTextInput == null) 
                // || theEvent.eventObject.staffInfo == null
               ? false : true
              // (staffText || staffTextInput) == 'null' || (staffText || staffTextInput) == '' ? true : false
            } 
           style={{textDecoration:'underline',marginRight:theWidth > 200 ?'5px':'', cursor:'pointer',width:theWidth < 170 ? '25px':'',maxWidth:'30px'
           
           }}>Slet
            </button> 
           
            <button  onClick={saveStaffInfo}
             disabled={(staffText || staffTextInput) == 'null' || ( staffTextInput.length < 1 )? true : false} 
           style={{textDecoration:'underline',marginRight:theWidth>140?'5px':'',width:theWidth < 170 ? '27px':'',maxWidth:'30px'
           
           }}>Gem
            </button> 
           
            </>
            : '' } 
           <button style={{marginRight: theWidth > 160?'-5px':''}} onClick={(e) => staffInfoClick(e)} >
                <svg style={{ transform: staffInfoShown?'rotate(180deg)' : ''}} xmlns="http://www.w3.org/2000/svg" width="8" height="10" viewBox="0 0 15 9" >
                  <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                  <g stroke="#46484c" strokeWidth="2.5">
                  <g>
                  <path d="M934 19.25L940.5 26.25 947 19.25" transform="translate(-1053 -509) translate(120 491)"/>
                   </g>
                   </g>
                   </g>
                </svg>  
            </button>
                   
        </div>
          </div>
            {staffInfoShown ?
             <div class="textarea" id='textarea' style={{border:  `1px solid ${timelineBackColor}`}}  onInput={(e) => handleStaffInfo(e)} contentEditable="true">
              {staffText ? staffText : staffInfoSaved === true ? staffTextInput : staffText }
              </div> 
              : ''}
    </div>

    <NoteModal shown={staffInfoShown  || reEdit  ||  webInfoShown || trailerDivOpen  } />

    <div style={{backgroundColor: extendedBackColor ,borderTop:'2px solid white',borderRadius:'4px',height:webInfoShown?'auto':'29px',fontSize:'12px',zIndex:webInfoShown?15:3,position:'relative',paddingTop:'3px',minHeight:webInfoShown?'70px':''}}>
      <div style={{display:'flex',justifyContent:'space-between',padding: theWidth > 170 ? '0px 10px' : theWidth > 140? '0px 5px ': ''}}>
        <div style={{position:'relative'}}>
          <span className='text_elip'  style={{marginTop:'2px',width: theWidth<140 ? '60px' :''}}>Note på webside</span>
         { alertWebinfo (theEvent) === true ? <img src={ alertIcon} alt='alert-icon' style={{position:'absolute', right:'-18px',top:'4px'}} /> : '' } 

      </div>
      <div> 
           {webInfoShown? 
           <>
           <button onClick={deleteWebInfo}
            disabled={ (webText === '' && webTextInput === '') || theEvent.eventObject.WebInfo == null ? true : false
              // (webText || webTextInput) == 'null' || (webText || webTextInput) == '' ? true : false
              }  style={{textDecoration:'underline',marginRight: theWidth > 200 ? '5px':'',width:theWidth < 170 ? '23px':'',maxWidth:'30px'}} >Slet</button> 

           <button onClick={saveWebInfo} 
           disabled={(webText || webTextInput) == 'null' || ( webTextInput.length < 1 )? true : false}  style={{textDecoration:'underline',marginRight:theWidth>200?'5px':'',width:theWidth < 170 ? '23px':'',maxWidth:'30px'}} >Gem</button> 
           </>
           : '' } 
           <button style={{marginRight:theWidth > 160?'-5px':''}} onClick={(e) => webInfoClick(e)} >
               <svg style={{ transform: webInfoShown?'rotate(180deg)' : ''}}xmlns="http://www.w3.org/2000/svg" width="8" height="10" viewBox="0 0 15 9" >
                  <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                  <g stroke="#46484c" strokeWidth="2.5">
                  <g>
                  <path d="M934 19.25L940.5 26.25 947 19.25" transform="translate(-1053 -509) translate(120 491)"/>
                   </g>
                   </g>
                   </g>
                </svg>  
            </button>
                   
        </div>
        </div>
        {webInfoShown ?
          <div class="textarea" id='textarea' style={{border:  `1px solid ${timelineBackColor}`}} onInput={(e) => handleWebInfo(e)} contentEditable="true"> {webText ? webText : webInfoSaved === true ? webTextInput : webText }</div>
                  
                   : ''}
    </div>
  {webInfoShown ? <><br></br> <br></br> </> : ''}
   <br></br> <br></br>
    </div>

     </div>
      
  )
}

export default FilmWidget